import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import "../../../6729.css";


import image1 from "../../../images/service-fluid/4211/4211_5front.webp"
import image2 from "../../../images/service-fluid/4211/4211_5back.webp"



const images = [
    { src: image1, alt: "Front" },
     { src: image2, alt: "Back 4L" },
    
];

const packageSlides = [
    { images: [image1, image2] },
];

const TDS_URL = "https://www.fanfaro.de/create-pdf/203";

// const SDS_FILES = [
//   { code: "BE", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(BE).pdf" },
//   { code: "BG", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(BG).pdf" },
//   { code: "CZ", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_CZ).pdf" },
//   { code: "DE", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(DE).pdf" },
//   { code: "DK", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(DK).pdf" },
//   { code: "EE", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(EE).pdf" },
//   { code: "ES", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_ES).pdf" },
//   { code: "FI", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(FI).pdf" },
//   { code: "FR", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(FR).pdf" },
//   { code: "GR", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(GR).pdf" },
//   { code: "HR", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(HR).pdf" },
//   { code: "HU", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(HU).pdf" },
//   { code: "IE (EN)", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(IE).pdf" },
//   { code: "IT", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(IT).pdf" },
//   { code: "LT", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(LT).pdf" },
//   { code: "LV", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(LV).pdf" },
//   { code: "NO", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_NO).pdf" },
//   { code: "PL", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(PL).pdf" },
//   { code: "PT", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(PT).pdf" },
//   { code: "RO", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_RO).pdf" },
//   { code: "RU", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(RU).pdf" },
//   { code: "SE", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(SE).pdf" },
//   { code: "SI", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_SI).pdf" },
//   { code: "SK", url: "https://sct-b2b.com/out/msds/sdFF3002_-_FANFARO 3002 DOT-4_(SK).pdf" }
// ];

export default function ImageWithContent() {

    const [currentIndex, setCurrentIndex] = useState(0);
    const [showModal, setShowModal] = useState(false);
    // const [showSDS, setShowSDS] = useState(false);

    const [packageIndex, setPackageIndex] = useState(0);
    const [imageIndex, setImageIndex] = useState(0);

    const slideInterval = useRef(null);
    const slideDuration = 4000;

    useEffect(() => {
        startSlideTimer();
        return () => clearInterval(slideInterval.current);
    }, []);

    const startSlideTimer = () => {
        slideInterval.current = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % images.length);
        }, slideDuration);
    };

    const goToSlide = (index) => {
        setCurrentIndex(index);
        clearInterval(slideInterval.current);
        startSlideTimer();
    };

    const nextImage = () => {
        const total = packageSlides[packageIndex].images.length;
        setImageIndex((prev) => (prev + 1) % total);
    };

    const prevImage = () => {
        const total = packageSlides[packageIndex].images.length;
        setImageIndex((prev) => (prev === 0 ? total - 1 : prev - 1));
    };

    return (
       <>
         <div
            style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "flex-start",
                justifyContent: "center",
                gap: "32px",
                padding: "24px",
                fontFamily: "Arial",
            }}
        >

            {/* LEFT IMAGE CAROUSEL */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>

        {/* IMAGE CAROUSEL */}
        <div
          style={{
            position: "relative",
            width: "300px",
            height: "400px",
            borderRadius: "8px",
            overflow: "hidden",
          }}
        >
          {images.map((img, index) => (
            <img
              key={index}
              src={img.src}
              alt={img.alt}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                position: index === currentIndex ? "relative" : "absolute",
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          ))}
        </div>
        <p
          style={{
            // marginTop: "15px",
            fontSize: "14px",
            color: "#0c0c0c",
            textAlign: "justify",
            lineHeight: "1.6",
            width:"250px",
            fontSize:"12px"
          }}
        >
          Attention! The packaging is illustrative and may differ from its actual appearance. For the latest list of specifications, see the text section.
        </p>


        
        {/* Amazon Button (external link) */}
        <a
          href="https://kytecarparts.com/products/fanfaro-4211-g11-coolant-ready-to-use-radiator-coolant-antifreeze-iat-silicate-nap-free-ethylene-glycol-formula-imported-from-germany-5l?"
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none" }}
        >
          <button
            style={{
              width: "150px",
              padding: "12px",
              backgroundColor: "#0d4d33",
              color: "#fff",
              border: "none",
              borderRadius: "6px",
              fontSize: "16px",
              cursor: "pointer",
            }}
          >
            Buy Now
          </button>
        </a>

      </div>

            {/* RIGHT CONTENT */}
            <div style={{ paddingLeft: "30px", maxWidth: "850px" }}>
                <h2>FF Coolant G11 4211</h2>

                <p>
A silicate (inorganic – IAT Inorganic Acid Technology) ready-for-use solution, designed for a year-round use in any modern cooling systems containing copper, brass and aluminium components for which the use of an ethylene-glycol-based antifreeze is recommended. </p>

                <p><strong>Product properties:</strong></p>

                <ul style={{ paddingLeft: "20px" }}>
                   <li>It ensures a reliable protection of metals and alloys (brass, copper, alloy-treated steel, cast iron, aluminium) from all forms of corrosion, as well as prevents a high-temperature corrosion of aluminium surfaces of modern engines;</li>
  <li>It protects from deposit formation;</li>
  <li>It has excellent heat conductivity properties and a resistance to foam formation;</li>
  <li>It is neutral to inserts and hoses, compatible with all types of rubber and plastic components of a cooling system;</li>
  <li>It is a silicate liquid with exceptional service qualities. It does not contain nitrates, phosphates, amines (the NAP free technology).</li>
                           </ul> <br />

                <p>
                Colour: blue.<br/>

Service life: 3 years.<br/>
Comply with the manufacturer’s instructions provided in the user’s manual! </p>


                <p style={{ color: "#4CAF50", fontWeight: "bold" }}>
                    CORRESPONDS WITH REQUIREMENTS / SPECIFICATIONS / PRODUCTS:
                </p>

                {/* SPECIFICATIONS */}
                <div style={{ display: "flex", gap: "40px", flexWrap: "wrap" }}>
                    <div>
                        <b>Specifications</b>
                        {/* <ul style={{ paddingLeft: "20px" }}>
                            <ul style={{ paddingLeft: "20px" }}>
                                <li>SAE J1703</li>
                                <li>SAE J1704</li>
                                <li>ISO 4925 Class 3</li>
                                <li>ISO 4925 Class 4</li>
                                <li>FMVSS 116 DOT 3</li>
                                <li>FMVSS 116 DOT 4</li>
                                <li>JIS K2233</li>
                            </ul>
                        </ul> */}
                    </div>


                    <div>
                        <b>Recommendation</b>
                        {/*  */}
                        <ul style={{paddingLeft: "20px"}}>
  <li>AFNOR FRANCE NF R15-601</li>
  <li>ASTM USA D3306</li>
  <li>BMW GS 94000</li>
  <li>BSI GB BS 6580:2010</li>
  <li>CHRYSLER MS-7170</li>
  <li>MAN 324 NF</li>
  <li>MINI GS 94000</li>
  <li>MTU MTL 5048</li>
  <li>OPEL GME L1301</li>
  <li>VAUXHALL GME L1301</li>
  <li>VOLKSWAGEN TL 774 C</li>
  <li>TESLA</li>
</ul>
                    </div>

                    <div>
                        <b>PACKAGES:</b>
                        <ul style={{ paddingLeft: "20px" }}>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(0);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                  FF4211 -5L
                                </span>
                            </li>
{/* 
                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(1);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                    20L (FF6208-60)
                                </span>
                            </li>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(2);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                    60L (FF6208-DR)
                                </span>
                            </li>

                            <li>
                                <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                        setPackageIndex(3);
                                        setImageIndex(0);
                                        setShowModal(true);
                                    }}
                                >
                                    208L (FF6208-IBC)
                                </span>
                            </li> */}

                        </ul>
                    </div>
                    <div>
                        <b>SDS & TDS</b>
                        <ul style={{ paddingLeft: "20px" }}>

                            {/* <li>
                                
                                <a
                                    href=""
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setShowSDS(true);
                                    }}
                                    style={{ textDecoration: "none", cursor: "pointer" }}
                                >
                                    📄 SDS
                                </a>
                            </li> */}

                            <li>
                                <a
                                    href="https://www.fanfaro.de/create-pdf/203"
                                    target="_blank"
                                    style={{ textDecoration: "none" }}>
                                    🖨️ TDS
                                </a>
                            </li>

                        </ul>
                    </div>

                </div>



            </div>

            {/* MODAL */}
            {showModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            padding: "20px",
                            width: "500px",
                            borderRadius: "8px",
                            position: "relative",
                        }}
                    >

                        <span
                            onClick={() => setShowModal(false)}
                            style={{
                                position: "absolute",
                                right: "15px",
                                top: "10px",
                                cursor: "pointer",
                                fontSize: "22px",
                            }}
                        >
                            ✕
                        </span>

                        <img
                            src={packageSlides[packageIndex].images[imageIndex]}
                            alt="package"
                            style={{
                                width: "100%",
                                maxHeight: "450px",
                                objectFit: "contain",
                            }}
                        />

                        <div style={{ textAlign: "center", marginTop: "20px" }}>

                            <button onClick={prevImage}>◀</button>

                            <span style={{ margin: "0 15px" }}>
                                {imageIndex + 1} of {packageSlides[packageIndex].images.length}
                            </span>

                            <button onClick={nextImage}>▶</button>

                        </div>

                    </div>
                </div>
            )}

            {/* {showSDS && (
                <div className="sds-overlay" onClick={() => setShowSDS(false)}>
                    <div className="sds-modal" onClick={(e) => e.stopPropagation()}>
                  
                        <button
                            className="sds-close-icon"
                            onClick={() => setShowSDS(false)}
                            aria-label="Close SDS"
                        >
                            ×
                        </button>

                        <h3>Back 4L FANFARO S-4T+ 20W-50</h3>

                        <div className="sds-grid">
                            {SDS_FILES.map((file) => (
                                <a
                                    key={file.code}
                                    href={file.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {file.code}
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            )} */}
        </div>

        <a
        href="https://wa.me/7204731100?text=Hello%20I%20need%20details"
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
          alt="WhatsApp"
        />
      </a>
       </>
    );
}